import React from "react";
import ChipSelect from "../../../components/chipSelect";
import FieldLabel from "../../../components/label";
import {
  Autocomplete,
  Box,
  Button,
  Checkbox,
  FormControlLabel,
  TextField,
  Typography,
} from "@mui/material";
import { useStyles } from "../indexFormStyles";
import { withStyles } from "@mui/styles";
import { getStorageItem } from "../../../helpers/utils";
import {
  AVIVA_PARTNER_CODE,
  DBGB_PARTNER_CODE,
  DEFAULT_PARTNER_CODE,
  TERM_PARTNER_CODE,
} from "../../../constants";
import { autoCompleteBranchName } from "../../../defaultValues/bank-details";

function SectionForm({
  classes: { contentScroller, formGroup },
  banks,
  branchName,
  errorMessage,
  form,
  handleChange,
  handleChangeChipSelect,
  handleTestDetailsCheckbox,
  handleVerifyClick,
  isTestDetails,
  options,
  salesPersonList = [],
  branchNameList = [],
  selectedBankOption,
  setSelectedBankOption,
  selectedSalesPersonOption,
  setSelectedSalesPersonOption,
  selectedBranchNameOption,
  setSelectedBranchNameOption,
  validateInputLength,
}) {
  return (
    <Box
      p={1}
      mt={0}
      mb={0}
      sx={{ height: window.screen.height <= 740 ? "460px" : "500px" }}
      className={contentScroller}
    >
      {getStorageItem("partnerCode") == DBGB_PARTNER_CODE && (
        <Box className={formGroup}>
          <FormControlLabel
            control={
              <Box style={{ alignSelf: "start" }}>
                <Checkbox
                  checked={isTestDetails}
                  onChange={handleTestDetailsCheckbox}
                  name={"isTestDetails"}
                  color="primary"
                />
              </Box>
            }
            label={
              <Box>
                <Typography variant="caption">
                  Allow other bank details for testing.
                </Typography>
              </Box>
            }
            sx={{ marginRight: "0px" }}
          />
        </Box>
      )}

      {getStorageItem("partnerCode") == DEFAULT_PARTNER_CODE && (
        <Box className={formGroup} pt={0}>
          <FieldLabel label={"Sales Person Name*"} />
          <Autocomplete
            disablePortal
            id="combo-box-demo"
            options={salesPersonList}
            value={selectedSalesPersonOption}
            onChange={(event, newValue) => {
              setSelectedSalesPersonOption(newValue);
            }}
            onInputChange={(event, inputValue, reason) => {
              if (reason === "input") {
                setSelectedBranchNameOption({ ...autoCompleteBranchName });
              }
            }}
            fullWidth
            renderInput={(params) => <TextField {...params} label="" />}
            sx={{
              "& + .MuiAutocomplete-popper .MuiAutocomplete-option": {
                backgroundColor: "#F6F6F6",
                fontWeight: "400 !important",
                display: "flex",
                justifyContent: "flex-start",
                textAlign: "left",
                margin: "2px 0px",
              },
            }}
          />
        </Box>
      )}

      {getStorageItem("partnerCode") == DEFAULT_PARTNER_CODE && (
        <Box className={formGroup} pt={0}>
          <FieldLabel label={"Sales Person Branch Name*"} />
          <Autocomplete
            disablePortal
            id="combo-box-demo"
            options={branchNameList}
            value={selectedBranchNameOption}
            onChange={(event, newValue) => {
              setSelectedBranchNameOption(newValue);
            }}
            fullWidth
            renderInput={(params) => <TextField {...params} label="" />}
            disabled={
              !branchNameList?.length ||
              !selectedSalesPersonOption?.code ||
              !selectedSalesPersonOption?.label
            }
            sx={{
              "& + .MuiAutocomplete-popper .MuiAutocomplete-option": {
                backgroundColor: "#F6F6F6",
                fontWeight: "400 !important",
                display: "flex",
                justifyContent: "flex-start",
                textAlign: "left",
                margin: "2px 0px",
              },
            }}
          />
        </Box>
      )}

      <Box className={formGroup} pt={0} pb={0}>
        <FieldLabel label={"Bank Name*"} />
        <Autocomplete
          disablePortal
          id="combo-box-demo"
          options={banks}
          value={selectedBankOption}
          onChange={(event, newValue) => {
            setSelectedBankOption(newValue);
          }}
          fullWidth
          renderInput={(params) => <TextField {...params} label="" />}
          disabled={
            getStorageItem("partnerCode") === AVIVA_PARTNER_CODE ||
            getStorageItem("partnerCode") === TERM_PARTNER_CODE
              ? false
              : true
          }
          sx={{
            "& + .MuiAutocomplete-popper .MuiAutocomplete-option": {
              backgroundColor: "#F6F6F6",
              fontWeight: "400 !important",
              display: "flex",
              justifyContent: "flex-start",
              textAlign: "left",
              margin: "2px 0px",
            },
          }}
        />
      </Box>

      <Box className={formGroup} pb={0}>
        <FieldLabel label={"Account Holder Name*"} />
        <TextField
          id="standard-basic"
          variant="outlined"
          value={form.bank_account_holder_name}
          name="bank_account_holder_name"
          onChange={handleChange}
          onInput={validateInputLength}
          autoComplete="off"
          helperText={errorMessage.bank_account_holder_name}
          disabled={true}
          fullWidth
        />
      </Box>
      <Box className={formGroup} pb={0}>
        <FieldLabel label={"Account Number*"} />
        <TextField
          id="standard-basic"
          variant="outlined"
          value={form.bank_account_number}
          name="bank_account_number"
          onChange={handleChange}
          onInput={validateInputLength}
          autoComplete="off"
          helperText={errorMessage.bank_account_number}
          disabled={form.verify_account_details}
          inputMode="numeric"
          fullWidth
        />
      </Box>
      <Box className={formGroup} pb={0}>
        <FieldLabel label={"IFSC Code*"} />
        <TextField
          id="standard-basic"
          variant="outlined"
          value={form.bank_ifsc_code}
          name="bank_ifsc_code"
          onChange={(e) => {
            if (
              isTestDetails ||
              getStorageItem("partnerCode") == AVIVA_PARTNER_CODE ||
              getStorageItem("partnerCode") == TERM_PARTNER_CODE
            ) {
              handleChange(e);
            } else {
              const inputValue = e.target.value;

              if (inputValue.length > 11) {
                return false;
              }

              // Allow changes only if the input length is within the limit
              if (inputValue.length > 6 && inputValue.length <= 11) {
                handleChange(e);
              }
            }
          }}
          onInput={(e) => {
            if (
              isTestDetails ||
              getStorageItem("partnerCode") == AVIVA_PARTNER_CODE ||
              getStorageItem("partnerCode") == TERM_PARTNER_CODE
            ) {
              validateInputLength(e);
            } else {
              const inputValue = e.target.value;

              if (inputValue.length > 11) {
                return false;
              }

              validateInputLength(e); // Optional validation function

              // Prevent editing the first 7 characters and restrict total length to 11
              if (inputValue.length <= 7) {
                e.target.value = inputValue.slice(0, 7);
              } else if (inputValue.length > 11) {
                e.target.value = inputValue.slice(0, 11);
              }
            }
          }}
          autoComplete="off"
          helperText={errorMessage.bank_ifsc_code}
          disabled={
            form.verify_account_details ||
            (!isTestDetails &&
              getStorageItem("partnerCode") == DBGB_PARTNER_CODE)
          }
          fullWidth
          inputProps={{ style: { textTransform: "uppercase" } }}
          // disabled={getStorageItem("partnerCode") == DBGB_PARTNER_CODE}
        />
      </Box>
      {!isTestDetails &&
        form.bank_ifsc_code &&
        !errorMessage.bank_ifsc_code &&
        getStorageItem("partnerCode") == DEFAULT_PARTNER_CODE && (
          <Box className={formGroup} textAlign="left" pt={0}>
            <Typography variant="caption" color="secondary">
              <small>{`Branch Name: ${
                branchName ? branchName : "Not Available"
              }`}</small>
            </Typography>
          </Box>
        )}

      <Box className={formGroup}>
        <FieldLabel label={"Account Type*"} />
        <Box display="flex">
          <ChipSelect
            compact={false}
            fontWeight={"regular"}
            fieldname={"bank_account_type"}
            handleChange={handleChangeChipSelect}
            options={options.bankAccountType}
            selectedItem={form?.bank_account_type}
            isMinWidth={true}
          />
        </Box>
      </Box>

      {form?.is_account_verified == true && (
        <Box className={formGroup} pt={0} pb={0}>
          <FieldLabel label={"I want to proceed with verified details*"} />
          <Box display="flex">
            <ChipSelect
              compact={false}
              fontWeight={"regular"}
              fieldname={"proceed_verified_account_details"}
              handleChange={handleChangeChipSelect}
              options={options.verifiedAccountDetails}
              selectedItem={form?.proceed_verified_account_details}
              isMinWidth={true}
            />
          </Box>
        </Box>
      )}
    </Box>
  );
}

export default withStyles(useStyles, { withTheme: true })(SectionForm);
